import { createContext } from "react";

const FilesoutputContext = createContext();

export default FilesoutputContext;
